/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-plusplus */
import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useSortBy, useTable, usePagination } from 'react-table';
import { useSticky } from 'react-table-sticky';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../../shared/images/teambuildr-selection.json';

const Styles = styled.div`
  align-items: flex-start;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  font-family: nunito sans;
  max-height: 70vh;
  pointer-events: auto;
  width: 100%;

  & .sticky {
    margin: 25px 0px;
    overflow-x: auto;
    width: 100%;

    [data-sticky-td] {
      position: sticky;
    }

    tfoot {
      td:first-child {
        border-bottom-left-radius: 8px;
        left: 0;
        position: sticky;
        z-index: 4;
      }
    }
  }

  .athleteColumnHeaderCell {
    border-bottom: none;
  }

  .athleteNameTitle {
    background-color: #F0F0F0;
    border-top-left-radius: 8px;
    color: #444444;
    cursor: pointer;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: bold;
    left: 0;
    max-width: 180px;
    min-width: 180px;
    position: sticky;
    text-align: left;
    top: 0;
    z-index: 4;
  }

  .footerCells {
    color: #444444;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: normal;
    position: sticky;
    bottom: 0;
    z-index: 3;

    :last-child {
      border-bottom-right-radius: 8px;
    }
  }

  .noHoverCategoryColumnTitleCell {
    background-color: #F0F0F0;
    border-right: 1px solid #BDBDBD1A;
    color: #444444;
    font-size: 16px;
    font-weight: bold;
    max-width: 270px;
    min-width: 270px;
    position: sticky;
    top: 0;
    z-index: 3;

    :last-child {
      border-top-right-radius: 8px;
    }
  }

  .noHoverCategoryColumnTitleCellFirst {
    background-color: #F0F0F0;
    border-right: 1px solid #BDBDBD1A;
    border-top-left-radius: 8px;
    color: #444444;
    font-size: 16px;
    font-weight: bold;
    max-width: 270px;
    min-width: 270px;
    position: sticky;
    top: 0;
    z-index: 3;
  }

  .pagination {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
  }

  .paginationButton {
    border: none;
    display: flex;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: bold;
    justify-content: center;
    padding: 5px;
  }

  .paginationContainer {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .rawValueTitle {
    background-color: #F0F0F0;
    color: #444444;
    cursor: pointer;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: normal;
    position: sticky;
    top: 56px;
    white-space: nowrap;
    z-index: 3;
  }

  table {
    border-collapse: separate;
    border-spacing: 0;

    th,
    td {
      background: white;
      border-bottom: 1px solid #e0e0e0;
      border-right: 1px solid #bdbdbd1a;
      margin: 0;
      padding: 15px;
      text-align: center;
    }

    tfoot {
      td:first-child {
        color: #444444;
        font-family: 'Nunito Sans';
        font-size: 16px;
        font-weight: normal;
        text-align: left;
      }

      tr:first-child {
        td {
          background: #F0F0F0;
          border-bottom: none;
          border-top: 1px solid #E0E0E0;
          height: 61px;
          min-height: 61px;
        }
      }

      tr:last-child {
        display: none;
      }
    }

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
  }

  td:has(div):has(.percentGreen) {
    background-color: #cff5e8;
  }

  td:has(div):has(.percentRed) {
    background-color: #ffcdcd;
  }
`;

const Table = ({
  columns, data, getCellProps, getHeaderProps, readyPrint,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 50 },
    },
    useSticky,
    useSortBy,
    usePagination,
  );

  const renderPageButtons = () => {
    const buttons = [];
    for (let i = 0; i < pageCount; i++) {
      buttons.push(
        <button
          className='paginationButton'
          type='button'
          key={i}
          onClick={() => gotoPage(i)}
          style={{ color: pageIndex === i ? '#FF6600' : '#616161' }}
        >
          {i + 1}
        </button>,
      );
    }
    return buttons;
  };

  useEffect(() => {
    if (readyPrint) {
      setPageSize(data.length);
    } else {
      setPageSize(50);
    }
  }, [readyPrint]);

  return (
    <>
      <div
        id='vbtAnalysisTable'
        style={{ display: 'flex', zIndex: 0 }}
        className='sticky'
      >
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup, i) => (
              <tr {...headerGroup.getHeaderGroupProps()} data-a-wrap>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps([
                      {
                        className: column.className,
                      },
                      getHeaderProps(column),
                    ])}
                    data-cols-width='30'
                    data-a-wrap
                    data-f-bold
                    data-fill-color={column?.style?.fillColor || 'FF424242'}
                    data-b-a-s='thin'
                    data-b-a-c='FF000000'
                    data-f-color={
                      column?.style?.fillColor ? 'FF000000;' : 'FFFFFFFF'
                    }
                    data-a-h='center'
                    data-a-v='center'
                  >
                    {column.render('Header')}
                    <span>
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <IcomoonReact
                            iconSet={iconSet}
                            size={10}
                            color='black'
                            icon='down-arrow'
                            style={{ marginLeft: '5px' }}
                          />
                        ) : (
                          <IcomoonReact
                            iconSet={iconSet}
                            size={10}
                            color='black'
                            icon='up-arrow'
                            style={{ marginLeft: '5px' }}
                          />
                        )
                      ) : (
                        ''
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td
                      {...cell.getCellProps([
                        {
                          style: cell.column.style,
                        },
                        getCellProps(cell),
                      ])}
                      data-fill-color={
                        getCellProps(cell)?.style?.fillColor || null
                      }
                      data-f-color={getCellProps(cell)?.style?.fontColor}
                      data-b-a-s='thin'
                      data-b-a-c='FF000000'
                      data-a-wrap
                    >
                      {cell.render('Cell')}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            {footerGroups.map((group) => (
              <tr {...group.getFooterGroupProps()}>
                {group.headers.map((column) => (
                  <td
                    data-a-wrap
                    {...column.getFooterProps([{ className: 'footerCells' }])}
                  >
                    {column.render('Footer')}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot>
        </table>
      </div>
      {pageCount > 1 ? (
        <div className='paginationContainer'>
          <div className='pagination'>
            <button
              className='paginationButton'
              type='button'
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
            >
              {'<'}
            </button>
            {' '}
            {renderPageButtons()}
            {' '}
            <button
              className='paginationButton'
              type='button'
              onClick={() => nextPage()}
              disabled={!canNextPage}
            >
              {'>'}
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
};

const VBTAnalysisTable = ({
  dataRows,
  groupData,
  readyPrint,
  threshold,
}) => {
  const chartRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);

  const handleScroll = (e) => {
    /** targetting the sticky container div scroll properties */
    const scrollWidth = chartRef.current?.childNodes[0]?.scrollWidth;
    const offsetWidth = chartRef.current?.childNodes[0]?.offsetWidth;
    const scrollLeft = chartRef.current?.childNodes[0]?.scrollLeft;
    setIsScrollable(offsetWidth + scrollLeft !== scrollWidth);
  };

  useEffect(() => {
    if (chartRef.current) {
      const scrollWidth = chartRef.current.childNodes[0]?.scrollWidth;
      const offsetWidth = chartRef.current.childNodes[0]?.offsetWidth;
      const scrollLeft = chartRef.current.childNodes[0]?.scrollLeft;
      setIsScrollable(offsetWidth + scrollLeft !== scrollWidth);
    }
  }, []);

  const athleteNameColumn = [
    {
      Header: '',
      Footer: () => null,
      id: 'name',
      className: 'athleteColumnHeaderCell',
      columns: [
        {
          Header: 'Athlete',
          accessor: 'name',
          Footer: 'Group Average',
          className: 'athleteNameTitle',
          style: {
            /** style for the whole column
             * className is style for just the header
             */
            borderRight: '1px solid #E0E0E0',
            color: '#444444',
            height: '58px',
            fontFamily: 'Nunito Sans',
            fontSize: '16px',
            fontWeight: 'normal',
            left: '0',
            position: 'sticky',
            textAlign: 'left',
            whiteSpace: 'nowrap',
          },
          Cell: ({ row }) => (
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <div
                style={{
                  borderRadius: '50%',
                  height: '35px',
                  marginRight: '5px',
                  overflow: 'hidden',
                  width: '35px',
                }}
              >
                <img
                  alt={`${row.original.name} icon`}
                  src={row.original.pic}
                  style={{ height: '100%' }}
                />
              </div>
              <div>{row.original.name}</div>
            </div>
          ),
        },
      ],
    },
  ];

  const formatColumns = () => {
    const formattedData = groupData.sets.map((set, i) => ({
      Header: `Set ${set.setNumber}`,
      Footer: () => null,
      id: `set_${set.setNumber}`,
      className: i === 0 ? 'noHoverCategoryColumnTitleCellFirst' : 'noHoverCategoryColumnTitleCell',
      columns: [
        {
          Header: 'Reps',
          accessor: (row) => row.sets[i]?.reps,
          sortType: (rowA, rowB, columnId, desc) => {
            const a = rowA.values[columnId];
            const b = rowB.values[columnId];

            if (a === null && b === null) return 0;
            if (a === null) return desc ? -1 : 1;
            if (b === null) return desc ? 1 : -1;

            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          },
          Cell: ({ row }) => {
            const value = row.original.sets[i]?.reps;
            if (threshold.min) {
              const thresholdVal = row.original.sets[i]?.meanVelocity;
              if (thresholdVal < threshold.min && thresholdVal !== 0) {
                return <div className='percentRed'>{value}</div>;
              }
              if (thresholdVal >= threshold.min && thresholdVal <= threshold.max) {
                return <div className='percentGreen'>{value}</div>;
              }
              return <div>{value || '-'}</div>;
            }
            return <div>{value || '-'}</div>;
          },
          Footer: () => {
            const total = set.reps;
            return total ? <>{total}</> : <>-</>;
          },
          id: `set_${set.setNumber}_reps`,
          className: 'rawValueTitle',
          style: {
            fillColor: 'FFBDBDBD1A',
            fontWeight: 700,
            maxWidth: '90px',
            minWidth: '90px',
          },
        },
        {
          Header: 'Load',
          accessor: (row) => row.sets[i]?.load,
          sortType: (rowA, rowB, columnId, desc) => {
            const a = rowA.values[columnId];
            const b = rowB.values[columnId];

            if (a === null && b === null) return 0;
            if (a === null) return desc ? -1 : 1;
            if (b === null) return desc ? 1 : -1;

            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          },
          Cell: ({ row }) => {
            const value = row.original.sets[i]?.load;
            if (threshold.min) {
              const thresholdVal = row.original.sets[i]?.meanVelocity;
              if (thresholdVal < threshold.min && thresholdVal !== 0) {
                return <div className='percentRed'>{value}</div>;
              }
              if (thresholdVal >= threshold.min && thresholdVal <= threshold.max) {
                return <div className='percentGreen'>{value}</div>;
              }
              return <div>{value || '-'}</div>;
            }
            return <div>{value || '-'}</div>;
          },
          Footer: () => {
            const total = set.load;
            return total ? <>{total}</> : <>-</>;
          },
          id: `set_${set.setNumber}_load`,
          className: 'rawValueTitle',
          style: {
            fillColor: 'FFBDBDBD1A',
            fontWeight: 700,
            maxWidth: '90px',
            minWidth: '90px',
          },
        },
        {
          Header: 'Avg. Velocity',
          accessor: (row) => {
            const value = row.sets[i]?.meanVelocity;
            return value !== '-' && value !== null ? parseFloat(value) : null;
          },
          sortType: (rowA, rowB, columnId, desc) => {
            const a = rowA.values[columnId];
            const b = rowB.values[columnId];

            if (a === null && b === null) return 0;
            if (a === null) return desc ? -1 : 1;
            if (b === null) return desc ? 1 : -1;

            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          },
          Cell: ({ row }) => {
            const value = row.original.sets[i]?.meanVelocity;
            if (threshold.min) {
              if (value < threshold.min && value !== 0) {
                return <div className='percentRed'>{value}</div>;
              }
              if (value >= threshold.min && value <= threshold.max) {
                return <div className='percentGreen'>{value}</div>;
              }
              return <div>{value || '-'}</div>;
            }
            return <div>{value || '-'}</div>;
          },
          Footer: () => {
            const total = set.meanVelocity;
            return total ? <>{total}</> : <>-</>;
          },
          id: `set_${set.setNumber}_avg_vel`,
          className: 'rawValueTitle',
          style: {
            fillColor: 'FFBDBDBD1A',
            fontWeight: 700,
            maxWidth: '90px',
            minWidth: '90px',
          },
        },
      ],
    }));
    return formattedData;
  };

  const formattedMiddleColumns = formatColumns();

  const columns = [...athleteNameColumn, ...formattedMiddleColumns];

  const memoizedColumns = React.useMemo(() => columns, [
    dataRows,
    threshold,
  ]);
  const memoizedDataRows = React.useMemo(() => dataRows, [
    dataRows,
    threshold,
  ]);

  const handleHeaderClick = (headerInfo) => {
    if (headerInfo.Header !== '') {
      headerInfo.toggleSortBy();
    }
  };

  return (
    <Styles
      ref={chartRef}
      onScroll={handleScroll}
      isScrollable={isScrollable}
    >
      <Table
        columns={memoizedColumns}
        data={memoizedDataRows}
        getCellProps={() => ({
          style: {
            backgroundColor: 'FFFFFFFF',
            color: 'FF444444',
            fillColor: 'FFFFFFFF',
            fontColor: 'FF444444',
          },
        })}
        getHeaderProps={(headerInfo) => ({
          onClick: () => handleHeaderClick(headerInfo),
        })}
        readyPrint={readyPrint}
      />
    </Styles>
  );
};

export default VBTAnalysisTable;
